import { Section } from './section'
import { HighlightCallout } from './highlight-callout'
import { BodyText, BulletList, Subheading, Subsection } from './styles'

export const Residential = () => {
  return (
    <Section title="Residential">
      <HighlightCallout
        variant="amber"
        title="Please provide original PDF documents where possible."
        description="Screenshots are not accepted and photos may delay your application."
      />
      <BodyText>
        Your addresses for the last 3 years. You'll enter each one, with dates.
      </BodyText>

      <Subsection>
        <Subheading>Proof of your current address</Subheading>
        <div>
          <BodyText>
            One of these, dated within the last 3 months and showing your name and address:
          </BodyText>
          <BulletList>
            <li>Utility bill</li>
            <li>Bank statement</li>
          </BulletList>
        </div>
      </Subsection>

      <Subsection>
        <Subheading>If you're renting now</Subheading>
        <BulletList>
          <li>
            Your current tenancy agreement — signed, showing the start and end dates
          </li>
          <li>
            Your last 3 bank statements — showing your rent payments. A large upfront rent
            payment is fine too.
          </li>
        </BulletList>
      </Subsection>
    </Section>
  )
}
